import { Select as AntSelect } from 'antd';
import { Spinner } from '@shared/ui';
import { useCategoriesQuery, useCategoryName } from '@entities/taxonomy';

interface CategorySelectProps {
  value: string | undefined;
  onChange: (id: string) => void;
  id?: string;
  invalid?: boolean;
  'aria-describedby'?: string;
}

export function CategorySelect({ value, onChange, id, invalid, ...aria }: CategorySelectProps) {
  // Product categories are the marketplace's PRODUCT kind — distinct from the
  // PRODUCER/ECO_PRODUCER kinds used on the manufacturer profile.
  const { data, isLoading } = useCategoriesQuery(['PRODUCT']);
  const localize = useCategoryName();

  if (isLoading) return <Spinner size="small" />;

  return (
    <AntSelect
      id={id}
      value={value || undefined}
      status={invalid ? 'error' : undefined}
      aria-describedby={aria['aria-describedby']}
      style={{ width: '100%' }}
      placeholder="Select category"
      onChange={(v) => onChange(v as string)}
      options={(data ?? []).map((c) => ({ value: c.id, label: localize(c) }))}
    />
  );
}
